module.exports = __webpack_public_path__ + "img/turn_bg.0164a169.png";